import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Sifu = () => {
  const { lang } = useLanguage();
  const t = useT(lang);

  return (
    <div className="py-24 md:py-32">
      <div className="container-wc">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="aspect-[3/4] overflow-hidden border border-goldSoft relative">
              <img
                src="https://www.wingchun.gr/wp-content/uploads/2026/07/Sifu.png"
                alt="Sifu Nikos Agathopoulos"
                className="w-full h-full object-cover img-moody"
                onError={(e) => { e.currentTarget.src = "https://images.pexels.com/photos/6253176/pexels-photo-6253176.jpeg?w=900"; }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
                <span className="font-cn text-gold text-3xl">師傅</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 fade-up">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-gold" />
              <span className="eyebrow">Sifu</span>
            </div>
            <h1 className="h-display text-5xl md:text-6xl mb-6">{t.sifu.title}</h1>
            <p className="text-gold text-xl font-serif italic mb-10">{t.sifu.subtitle}</p>

            <div className="space-y-6 text-lg leading-relaxed text-[#E8E8E0]">
              <p>{t.sifu.p1}</p>
              <p>{t.sifu.p2}</p>
              <p>{t.sifu.p3}</p>
            </div>

            <div className="mt-12 p-8 bg-surface border-l-2 border-gold">
              <h3 className="font-serif text-2xl mb-3">{t.sifu.role_title}</h3>
              <p className="text-dim leading-relaxed">{t.sifu.role_text}</p>
            </div>

            <div className="mt-12">
              <Link to="/contact" data-testid="sifu-cta" className="btn-primary">
                {t.hero.cta_primary} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sifu;
